import {
    createUnknownComponentVNode as _$cc,
    createElementVNode as _$ce,
    map as _$ma,
    className as _$cn,
} from 'intact';
import {TransitionGroup} from 'intact';
import {makeNotificationsStyles} from './styles';
import { ConfigProvider } from '../config';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const k = this.get('classNamePrefix') || this.config.k;
    const position = this.get('position') || 'topRight';
    
    return _$cc(ConfigProvider, {
        'value': {classNamePrefix: k},
        'children': (
            _$ce(2, 'div', (
                _$cc(TransitionGroup, {
                    'onAfterLeave': this.onAfterLeave.bind(this),
                    'children': (
                        _$ma(this.notifications, function($value, $key) {
                            return $value;
                        }, $this)
                    )
                })
            ), 2 /* HasVNodeChildren */, _$cn({[`${k}-notifications`]: true, [makeNotificationsStyles(k, position)]: true}))
        )
    });
};